<template>
  <div style="background-color: #eeeeee">
    <div class="md-layout">
      <div
        class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25"
      >
        <md-card class="md-card-stats">
          <md-card-header style="background-color: purple">
            <slot name="header">
              <md-icon>add_alert</md-icon>
            </slot>
          </md-card-header>
          <md-card-content>
            <slot name="content">
              <p class="category">Abertos Hoje</p>
              <h3 class="title">
                {{ openedToday }}
              </h3>
            </slot>
          </md-card-content>
          <md-card-actions md-alignment="left">
            <slot name="footer" />
          </md-card-actions>
        </md-card>
      </div>

      <div
        class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25"
      >
        <md-card class="md-card-stats">
          <md-card-header style="background-color: red">
            <slot name="header">
              <md-icon>warning</md-icon>
            </slot>
          </md-card-header>
          <md-card-content>
            <slot name="content">
              <p class="category">Pendentes</p>
              <h3 class="title">
                {{ pendingTickets }}
              </h3>
            </slot>
          </md-card-content>
          <md-card-actions md-alignment="left">
            <slot name="footer" />
          </md-card-actions>
        </md-card>
      </div>

      <div
        class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25"
      >
        <md-card class="md-card-stats">
          <md-card-header style="background-color: green">
            <slot name="header">
              <router-link to="/finance">
                <md-icon>calendar_today</md-icon>
              </router-link>
            </slot>
          </md-card-header>
          <md-card-content>
            <slot name="content">
              <p class="category">Mês</p>
              <h3 class="title">
                {{ monthTickets }}
              </h3>
            </slot>
          </md-card-content>
          <md-card-actions md-alignment="left">
            <slot name="footer" />
          </md-card-actions>
        </md-card>
      </div>

      <div
        class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25"
      >
        <md-card class="md-card-stats">
          <md-card-header style="background-color: blue">
            <slot name="header">
              <router-link to="/finance">
                <md-icon>date_range</md-icon>
              </router-link>
            </slot>
          </md-card-header>
          <md-card-content>
            <slot name="content">
              <p class="category">Total</p>
              <h3 class="title">
                {{ totalTickets }}
              </h3>
            </slot>
          </md-card-content>
          <md-card-actions md-alignment="left">
            <slot name="footer" />
          </md-card-actions>
        </md-card>
      </div>

      <div
        class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-33"
      >
        <md-card>
          <md-card-header data-background-color="green">
            <h4 class="title">
              Modalidades - {{ pastMonth }} {{ pastMonthYear }}
            </h4>
          </md-card-header>
          <loading :loading="!pastMonthModalityChartData">
            <pie-chart
              :aspect-ratio="1.33"
              :chart-data="pastMonthModalityChartData"
              :show-legend="showChartsLegend"
            />
          </loading>
        </md-card>
      </div>

      <div
        class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-33"
      >
        <md-card>
          <md-card-header data-background-color="green">
            <h4 class="title">Evolução - Ordens de Serviço</h4>
          </md-card-header>
          <loading :loading="!evolutionChartData">
            <bar-chart
              :aspect-ratio="1.33"
              :chart-data="evolutionChartData"
              :show-legend="showChartsLegend"
            />
          </loading>
        </md-card>
      </div>

      <div
        class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-33"
      >
        <md-card>
          <md-card-header data-background-color="green">
            <h4 class="title">
              Categorias - {{ pastMonth }} {{ pastMonthYear }}
            </h4>
          </md-card-header>
          <loading :loading="!pastMonthCategoriesChartData">
            <pie-chart
              :aspect-ratio="1.33"
              :chart-data="pastMonthCategoriesChartData"
              :show-legend="showChartsLegend"
            />
          </loading>
        </md-card>
      </div>

      <div
        class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-50"
      >
        <md-card>
          <md-card-header data-background-color="green">
            <h4 class="title">Chamados por Modalidade - {{ pastMonthYear }}</h4>
          </md-card-header>
          <loading :loading="!pastYearModalitiesChartData">
            <bar-chart
              :stacked="true"
              :chart-data="pastYearModalitiesChartData"
              :show-legend="showChartsLegend"
              :show-labels="true"
            />
          </loading>
        </md-card>
      </div>

      <div
        class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-50"
      >
        <md-card>
          <md-card-header data-background-color="green">
            <h4 class="title">Chamados por Categoria - {{ pastMonthYear }}</h4>
          </md-card-header>
          <loading :loading="!pastYearCategoriesChartData">
            <bar-chart
              :stacked="true"
              :chart-data="pastYearCategoriesChartData"
              :show-legend="showChartsLegend"
              :show-labels="true"
            />
          </loading>
        </md-card>
      </div>

      <div
        class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-50"
      >
        <md-card>
          <md-card-header data-background-color="green">
            <h4 class="title">Chamados por Tipo - {{ pastMonthYear }}</h4>
          </md-card-header>
          <loading :loading="!ticketsByTypeChartData">
            <bar-chart
              :stacked="true"
              :chart-data="ticketsByTypeChartData"
              :show-legend="showChartsLegend"
              :show-labels="true"
            />
          </loading>
        </md-card>
      </div>

      <div
        class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-50"
      >
        <md-card>
          <md-card-header data-background-color="green">
            <h4 class="title">
              Incidentes por Categoria - {{ pastMonthYear }}
            </h4>
          </md-card-header>
          <loading :loading="!incidentsByCategoryChartData">
            <bar-chart
              :stacked="true"
              :chart-data="incidentsByCategoryChartData"
              :show-legend="showChartsLegend"
              :show-labels="true"
            />
          </loading>
        </md-card>
      </div>

      <div
        class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-50"
      >
        <md-card>
          <md-card-header data-background-color="green">
            <h4 class="title">Últimos 10 Chamados</h4>
          </md-card-header>
          <md-card-content>
            <loading :loading="newestTickets.loading">
              <md-table v-model="newestTickets.data" table-header-color="gray">
                <md-table-empty-state md-label="Nenhum dado encontrado..." />

                <md-table-row slot="md-table-row" slot-scope="{ item }">
                  <md-table-cell md-label="Título">
                    {{ item.title }}
                  </md-table-cell>
                  <md-table-cell md-label="Data">
                    {{ item.date }}
                  </md-table-cell>
                  <md-table-cell md-label="Status">
                    {{ item.status }}
                  </md-table-cell>
                  <md-table-cell md-label="Modalidade">
                    {{ item.modality }}
                  </md-table-cell>
                  <md-table-cell md-label="ID">
                    <a class="fa fa-edit" :href="'/openticket/' + item.id">{{
                      item.id
                    }}</a>
                  </md-table-cell>
                </md-table-row>
              </md-table>
            </loading>
          </md-card-content>
        </md-card>
      </div>

      <div
        class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-50"
      >
        <md-card>
          <md-card-header data-background-color="green">
            <h4 class="title">Atividades para hoje</h4>
          </md-card-header>
          <md-card-content>
            <loading :loading="todayTickets.loading">
              <md-table v-model="todayTickets.data" table-header-color="gray">
                <md-table-empty-state md-label="Nenhum dado encontrado..." />

                <md-table-row slot="md-table-row" slot-scope="{ item }">
                  <md-table-cell md-label="Título">
                    {{ item.title }}
                  </md-table-cell>
                  <md-table-cell md-label="Data">
                    {{ item.date }}
                  </md-table-cell>
                  <md-table-cell md-label="Status">
                    {{ item.status }}
                  </md-table-cell>
                  <md-table-cell md-label="Modalidade">
                    {{ item.modality }}
                  </md-table-cell>
                  <md-table-cell md-label="ID">
                    <a class="fa fa-edit" :href="'/openticket/' + item.id">{{
                      item.id
                    }}</a>
                  </md-table-cell>
                </md-table-row>

                <pagination
                  :page-size="todayTickets.pageSize"
                  :total-items="todayTickets.total"
                  :current-page="todayTickets.page"
                  @updatePage="updateTodayTickets"
                />
              </md-table>
            </loading>
          </md-card-content>
        </md-card>
      </div>
    </div>

    <new-ticket-button />

    <options-button>
      <options-button-item @click="showChartsLegend = !showChartsLegend">
        {{ showChartsLegend ? "Desabilitar legendas" : "Habilitar legendas" }}
      </options-button-item>
    </options-button>
  </div>
</template>

<script>
import { DateTime } from "luxon";

import Loading from "../components/Loading.vue";
import BarChart from "../components/BarChart.vue";
import Pagination from "../components/Pagination.vue";
import OptionsButton from "../components/OptionsButton";
import OptionsButtonItem from "../components/OptionsButtonItem";
import NewTicketButton from "../components/NewTicketButton.vue";
import PieChart from "../components/PieChart.vue";

import { MAP_MODALITY_COLORS } from "../util/map-modality-colors";
import { uniquePropArray } from "../util/unique-prop-array";
import { generateLookupMap } from "../util/generate-lookup-map";
import { unescapeHtml } from "../util/unescape-html";

import { EventBus, events } from "../_helpers/event-bus";

import { getUserSession } from "../_services/localstorage";
import { clientcompliance, originalEquipmentModels } from "../_services";
import {
  getByCategories,
  getByModalities,
  getIncidentsByCategory,
  getKpis,
  getNewestTickets,
  getOsEvolution,
  getTicketsByType,
  getTodayTickets,
} from "../_services/reports.service";
import { parseTime } from "../util/parse-time";
import { MONTHS } from "../util/months";

const MAP_CATEGORY_COLORS = new Map([
  ["automação", "#3366cc"],
  ["civil", "#dc3912"],
  ["clima", "#ff9900"],
  ["conectividade", "#109618"],
  ["documentos", "#990099"],
  ["energia", "#0099c6"],
  ["manutenção preventiva", "#dd4477"],
  ["manutenção preventiva", "#66aa00"],
  ["preditiva", "#b82e2e"],
  ["relatórios", "#3366cc"],
  ["ronda", "#316395"],
  ["segurança", "#994499"],
  ["visita técnica", "#22aa99"],
]);

const TICKET_TYPE_COLORS = new Map([
  ["incidente", "#dc3912"],
  ["requisição", "#3366cc"],
]);

export default {
  components: {
    OptionsButton,
    OptionsButtonItem,
    BarChart,
    Loading,
    PieChart,
    Pagination,
    NewTicketButton,
  },
  data() {
    return {
      showChartsLegend: true,

      pastMonthPeriod: {
        startDate: DateTime
          .now()
          .minus({ month: 1 })
          .startOf("month"),
        endDate: DateTime
          .now()
          .minus({ month: 1 })
          .endOf("month"),
      },
      pastYearPeriod: {
        startDate: DateTime
          .now()
          .minus({ year: 1 })
          .plus({ month: 1 })
          .startOf("month"),
        endDate: DateTime
          .now()
          .endOf("month"),
      },

      openedToday: 0,
      pendingTickets: 0,
      monthTickets: 0,
      totalTickets: 0,

      ticketsByTypeChartData: null,
      incidentsByCategoryChartData: null,
      pastMonthModalityChartData: null,
      pastMonthCategoriesChartData: null,
      evolutionChartData: null,
      pastYearModalitiesChartData: null,
      pastYearCategoriesChartData: null,

      newestTickets: {
        data: [],
        loading: false,
      },
      todayTickets: {
        pageSize: 10,
        total: 0,
        page: 1,
        data: [],
        loading: false,
      },
    };
  },
  computed: {
    pastMonth() {
      return MONTHS[this.pastMonthPeriod.startDate.get("month") - 1];
    },
    pastMonthYear() {
      return this.pastMonthPeriod.startDate.get("year");
    },
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener("resize", this.calculateShowLegend);
    });
  },
  async created() {
    await this.initialize();
    EventBus.$on(events.CHANGED_ENTITY, this.initialize);
  },
  beforeDestroy() {
    EventBus.$off(events.CHANGED_ENTITY, this.initialize);
    window.removeEventListener("resize", this.calculateShowLegend);
  },
  methods: {
    async initialize() {
      this.user = getUserSession();
      this.user = clientcompliance.getDetails(this.user);
      this.calculateShowLegend();
      this.initializeRenameCategoryMap();
      await this.loadData();
    },
    async loadData() {
      this.resetData();

      await Promise.allSettled([
        this.getKpisData(),
        this.getNewestTicketsData(),
        this.getByModalitiesData({
          startDate: this.pastMonthPeriod.startDate.toISO(),
          endDate: this.pastMonthPeriod.endDate.toISO(),
          parseFn: this.parseResponseModalityPieChart,
        }),
        this.getByCategoriesData({
          startDate: this.pastMonthPeriod.startDate.toISO(),
          endDate: this.pastMonthPeriod.endDate.toISO(),
          parseFn: this.parseResponseCategoryPieChart,
        }),
        this.getOsEvolutionData({
          startDate: this.pastYearPeriod.startDate.toISO(),
          endDate: this.pastYearPeriod.endDate.toISO(),
        }),
        this.getTicketsByTypeData({
          startDate: this.pastYearPeriod.startDate.toISO(),
          endDate: this.pastYearPeriod.endDate.toISO(),
        }),
        this.getIncidentsByCategoryData({
          startDate: this.pastYearPeriod.startDate.toISO(),
          endDate: this.pastYearPeriod.endDate.toISO(),
        }),
        this.getByModalitiesData({
          startDate: this.pastYearPeriod.startDate.toISO(),
          endDate: this.pastYearPeriod.endDate.toISO(),
          parseFn: this.parseResponseModalityStackedChart,
        }),
        this.getByCategoriesData({
          startDate: this.pastYearPeriod.startDate.toISO(),
          endDate: this.pastYearPeriod.endDate.toISO(),
          parseFn: this.parseResponseCategoryStackedChart,
        }),
        this.updateTodayTickets(
          this.todayTickets.page,
          this.todayTickets.pageSize,
        ),
      ]);
    },
    async getKpisData() {
      try {
        const kpis = await getKpis();
        ({
          openedToday: this.openedToday,
          pendingTickets: this.pendingTickets,
          monthTickets: this.monthTickets,
          totalTickets: this.totalTickets,
        } = kpis); // destructuring and assign to this
      } catch (e) {
        // TODO handle error and give a user feedback
        console.error(e);
      }
    },
    async getOsEvolutionData({ startDate, endDate }) {
      try {
        const evolutionData = await getOsEvolution({ startDate, endDate });

        this.evolutionChartData = {
          labels:
            (evolutionData &&
              evolutionData.map(({ time }) => parseTime(time))) ||
            [],
          datasets:
            (evolutionData && [
              {
                label: "Chamados",
                data: evolutionData.map(({ total }) => total),
                backgroundColor: "#3366CC",
              },
            ]) ||
            [],
        };
      } catch (e) {
        console.error(e); // TODO handle error and give user feedback
      }
    },
    async getTicketsByTypeData({ startDate, endDate }) {
      try {
        const data = await getTicketsByType({ startDate, endDate });

        const types = uniquePropArray(data, "ticketType");
        const times = uniquePropArray(data, "time");
        const lookup = generateLookupMap(data, ["time", "ticketType"], "total");

        this.ticketsByTypeChartData = {
          labels: times.map(parseTime),
          datasets: types.map((ticketType) => ({
            label: ticketType,
            data: times.map((time) => lookup[time][ticketType] || 0),
            backgroundColor:
              TICKET_TYPE_COLORS.get(ticketType.toLowerCase()) || "#3366CC",
          })),
        };
      } catch (e) {
        console.error(e); // TODO handle error and give user feedback
      }
    },
    async getIncidentsByCategoryData({ startDate, endDate }) {
      try {
        const data = await getIncidentsByCategory({ startDate, endDate });

        const categories = uniquePropArray(data, "category");
        const times = uniquePropArray(data, "time");
        const lookup = generateLookupMap(data, ["time", "category"], "total");

        this.incidentsByCategoryChartData = {
          labels: times.map(parseTime),
          datasets: categories.map((category) => ({
            label: category,
            data: times.map((time) => lookup[time][category] || 0),
            backgroundColor:
              MAP_CATEGORY_COLORS.get(category.toLowerCase()) || "#3366CC",
          })),
        };
      } catch (e) {
        console.error(e); // TODO handle error and give user feedback
      }
    },
    async getByModalitiesData({ startDate, endDate, parseFn }) {
      try {
        const res = await getByModalities({
          startDate,
          endDate,
        });

        parseFn && parseFn(res);
      } catch (e) {
        console.error(e); // TODO handle error and give a user feedback
      }
    },
    async getByCategoriesData({ startDate, endDate, parseFn }) {
      try {
        const res = await getByCategories({
          startDate,
          endDate,
        });

        parseFn && parseFn(res);
      } catch (e) {
        console.error(e); // TODO handle error and give a user feedback
      }
    },
    async getNewestTicketsData() {
      this.newestTickets.loading = true;

      const { result } = await getNewestTickets();

      this.newestTickets = {
        data: this.formatTableDataset(result),
        loading: false,
      };
    },
    async updateTodayTickets(page, limit, done) {
      this.todayTickets.loading = true;
      const offset = (page - 1) * limit;
      const { total, result } = await getTodayTickets({ limit, offset });
      this.todayTickets = {
        pageSize: limit,
        total,
        page,
        data: this.formatTableDataset(result),
        loading: false,
      };
      done && done();
    },
    initializeRenameCategoryMap() {
      this.renameCategoryMap = new Map();
      originalEquipmentModels.forEach((originalEquipmentModel) => {
        const customizedEquipment = this.user.equipmentModels.find(
          (equipment) => equipment.itemtype === originalEquipmentModel.itemtype,
        );
        if (
          customizedEquipment &&
          originalEquipmentModel.name !== customizedEquipment.name
        ) {
          this.renameCategoryMap.set(
            originalEquipmentModel.name,
            customizedEquipment.name,
          );
        }
      });
    },
    resetData() {
      this.pastMonthModalityChartData = null;
      this.pastMonthCategoriesChartData = null;
      this.evolutionChartData = null;
      this.pastYearModalitiesChartData = null;
      this.pastYearCategoriesChartData = null;

      this.newestTickets = {
        data: [],
        loading: false,
      };
      this.todayTickets = {
        pageSize: 10,
        total: 0,
        page: 1,
        data: [],
        loading: false,
      };
    },
    formatTableDataset(dataset) {
      return dataset.map((data) => ({
        ...data,
        title: unescapeHtml(data.title),
        date: DateTime
          .fromISO(data.date)
          .toFormat("dd/MM/yyyy"),
        status: this.user.convertStatus[data.status || 0],
      }));
    },
    calculateShowLegend() {
      this.showChartsLegend = window.innerWidth >= 1800;
    },
    parseResponseModalityPieChart(response) {
      const modalities = uniquePropArray(response, "modality");
      const lookup = generateLookupMap(response, ["modality"], "total");
      this.pastMonthModalityChartData = {
        labels: modalities,
        datasets: [
          {
            label: "Modality Dataset",
            data: modalities.map((modality) => lookup[modality]),
            backgroundColor: modalities.map(
              (modality) =>
                MAP_MODALITY_COLORS.get(modality.toLowerCase()) || "#3366CC",
            ),
          },
        ],
      };
    },
    parseResponseCategoryPieChart(response) {
      const categories = uniquePropArray(response, "category").filter(
        (category) =>
          this.user.activeentity === 595 ||
          this.user.convertCategories.includes(category),
      );

      const lookup = generateLookupMap(response, ["category"], "total");
      this.pastMonthCategoriesChartData = {
        labels: categories.map(
          (category) => this.renameCategoryMap.get(category) || category,
        ),
        datasets: [
          {
            label: "Category Dataset",
            data: categories.map((category) => lookup[category]),
            backgroundColor: categories.map(
              (category) =>
                MAP_CATEGORY_COLORS.get(category.toLowerCase()) || "#3366CC",
            ),
          },
        ],
      };
    },
    parseResponseModalityStackedChart(response) {
      const labelsModalities = uniquePropArray(response, "time");
      const distinctModalities = uniquePropArray(response, "modality");
      const pastYearModalitiesLookup = generateLookupMap(
        response,
        ["modality", "time"],
        "total",
      );
      this.pastYearModalitiesChartData = {
        labels: labelsModalities.map(parseTime),
        datasets: distinctModalities.map((modality) => ({
          label: modality,
          data: labelsModalities.map(
            (time) => pastYearModalitiesLookup[modality][time] || 0,
          ),
          backgroundColor:
            MAP_MODALITY_COLORS.get(modality.toLowerCase()) || "#3366CC",
        })),
      };
    },
    parseResponseCategoryStackedChart(response) {
      const labelsCategories = uniquePropArray(response, "time");
      const distinctCategories = uniquePropArray(response, "category").filter(
        (category) =>
          this.user.activeentity === 595 ||
          this.user.convertCategories.includes(category),
      );
      const pastYearCategoriesLookup = generateLookupMap(
        response,
        ["category", "time"],
        "total",
      );
      this.pastYearCategoriesChartData = {
        labels: labelsCategories.map(parseTime),
        datasets: distinctCategories.map((category) => ({
          label: this.renameCategoryMap.get(category) || category,
          data: labelsCategories.map(
            (time) => pastYearCategoriesLookup[category][time] || 0,
          ),
          backgroundColor:
            MAP_CATEGORY_COLORS.get(category.toLowerCase()) || "#3366CC",
        })),
      };
    },
  },
};
</script>
